<template>
  <div class="file-list">
    <div class="file-item" v-for="item in fileList" :key="item.label">
      <strong>版本:{{item.label}}</strong>
      <div class="file-url" v-for="subitem in item.linkList" :key="subitem">
        <p class="file-link"><i></i>{{subitem}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'file-list',
  props: ['fileList']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FileList.vue